export const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" }
];
export const statusOptions = [
    { value: true, label: "Active" },
    { value: false, label: "InActive" },
];

export const roelOptions = [
    { value: "SuperAdmin", label: "SuperAdmin" },
    { value: "Admin", label: "Admin" },
    { value: "Staff", label: "Staff" }
];

export const expenseCategoryOptions = [
    { value: "Full time employees salaries", label: "Full time employees salaries" },
    { value: "Incentives", label: "Incentives" },
    { value: "Intern & freelancer payouts", label: "Intern & freelancer payouts" },
    { value: "Staff Welfare Exp", label: "Staff Welfare Exp" },
    { value: "Business Promotion Exp", label: "Business Promotion Exp" },
    { value: "Hotel accommodation", label: "Hotel accommodation" },
    { value: "Travelling exp", label: "Travelling exp" },
    { value: "Advertisement", label: "Advertisement" },
    { value: "Marketing Exp", label: "Marketing Exp" },
    { value: "Rent", label: "Rent" },
    { value: "Electricity", label: "Electricity" },
    { value: "Office exp", label: "Office exp" },
    { value: "Maintenance", label: "Maintenance" },
    { value: "Water exp", label: "Water exp" },
    { value: "Internet exp", label: "Internet exp" },
    { value: "Telephone exp", label: "Telephone exp" },
    { value: "Repairing charges", label: "Repairing charges" },
    { value: "Printing & stationery", label: "Printing & stationery" },
    { value: "Professional fees", label: "Professional fees" },
    { value: "Software exp", label: "Software exp" },
    { value: "Other Exp", label: "Other Exp" }
];

export const paymentMethodOptions = [
    { value: "Cash", label: "Cash" },
    { value: "Credit Card", label: "Credit Card" },
    { value: "Debit Card", label: "Debit Card" },
    { value: "UPI", label: "UPI" },
    { value: "Bank Transfer", label: "Bank Transfer" },

];

export const reimbursementOptions = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" }
];


export const dashboardOptions = [
    { label: 'All Records', value: '' },
    { label: 'Today', value: 'today' },
    { label: 'This Week', value: 'currentWeek' },
    { label: 'This Month', value: 'currentMonth' },
    { label: 'Last 7 Days', value: 'last7Days' },
    { label: 'Last 30 Days', value: 'last30Days' },
    { label: 'Date Range', value: 'daterange' },
];
